import type { Theme } from "../types";

/** Light themes: zinc through tangerine */
export const bundle01: Theme[] = [
  {
    colors: {
      accent: "oklch(0.967 0.001 286.375)",
      accentForeground: "oklch(0.21 0.006 285.885)",
      background: "oklch(1 0 0)",
      border: "oklch(0.92 0.004 286.32)",
      card: "oklch(1 0 0)",
      cardForeground: "oklch(0.141 0.005 285.823)",
      chartColors: [
        "oklch(0.646 0.222 41.116)",
        "oklch(0.6 0.118 184.704)",
        "oklch(0.398 0.07 227.392)",
        "oklch(0.828 0.189 84.429)",
        "oklch(0.769 0.188 70.08)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.141 0.005 285.823)",
      input: "oklch(0.92 0.004 286.32)",
      muted: "oklch(0.967 0.001 286.375)",
      mutedForeground: "oklch(0.552 0.016 285.938)",
      popover: "oklch(1 0 0)",
      popoverForeground: "oklch(0.141 0.005 285.823)",
      primary: "oklch(0.21 0.006 285.885)",
      primaryForeground: "oklch(0.985 0 0)",
      ring: "oklch(0.705 0.015 286.067)",
      secondary: "oklch(0.967 0.001 286.375)",
      secondaryForeground: "oklch(0.21 0.006 285.885)",
      sidebar: "oklch(0.985 0 0)",
      sidebarAccent: "oklch(0.967 0.001 286.375)",
      sidebarAccentForeground: "oklch(0.21 0.006 285.885)",
      sidebarBorder: "oklch(0.92 0.004 286.32)",
      sidebarForeground: "oklch(0.141 0.005 285.823)",
      sidebarPrimary: "oklch(0.21 0.006 285.885)",
      sidebarPrimaryForeground: "oklch(0.985 0 0)",
      sidebarRing: "oklch(0.705 0.015 286.067)",
    },
    isDark: false,
    label: "Zinc",
    name: "zinc-light",
    pair: "zinc-dark",
    swatches: ["#fafafa", "#18181b", "#71717a", "#e4e4e7"],
  },
  {
    colors: {
      accent: "oklch(0.94 0.03 12)",
      accentForeground: "oklch(0.35 0.12 13)",
      background: "oklch(0.995 0.004 12)",
      border: "oklch(0.91 0.02 12)",
      card: "oklch(0.995 0.004 12)",
      cardForeground: "oklch(0.178 0.042 18)",
      chartColors: [
        "oklch(0.65 0.2 13)",
        "oklch(0.7 0.15 350)",
        "oklch(0.55 0.18 25)",
        "oklch(0.8 0.12 20)",
        "oklch(0.75 0.16 5)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.178 0.042 18)",
      input: "oklch(0.91 0.02 12)",
      muted: "oklch(0.955 0.015 12)",
      mutedForeground: "oklch(0.55 0.06 12)",
      popover: "oklch(0.995 0.004 12)",
      popoverForeground: "oklch(0.178 0.042 18)",
      primary: "oklch(0.455 0.188 13.7)",
      primaryForeground: "oklch(0.98 0.005 12)",
      ring: "oklch(0.65 0.15 13)",
      secondary: "oklch(0.955 0.015 12)",
      secondaryForeground: "oklch(0.35 0.12 13)",
      sidebar: "oklch(0.98 0.006 12)",
      sidebarAccent: "oklch(0.94 0.03 12)",
      sidebarAccentForeground: "oklch(0.35 0.12 13)",
      sidebarBorder: "oklch(0.91 0.02 12)",
      sidebarForeground: "oklch(0.178 0.042 18)",
      sidebarPrimary: "oklch(0.455 0.188 13.7)",
      sidebarPrimaryForeground: "oklch(0.98 0.005 12)",
      sidebarRing: "oklch(0.65 0.15 13)",
    },
    isDark: false,
    label: "Rose",
    name: "rose-light",
    pair: "rose-pine-dark",
    swatches: ["#fff1f2", "#9f1239", "#fb7185", "#fecdd3"],
  },
  {
    colors: {
      accent: "oklch(0.85 0.015 100)",
      accentForeground: "oklch(0.28 0.01 250)",
      background: "oklch(0.92 0.008 100)",
      border: "oklch(0.83 0.012 100)",
      card: "oklch(0.92 0.008 100)",
      cardForeground: "oklch(0.28 0.01 250)",
      chartColors: [
        "oklch(0.78 0.17 85)",
        "oklch(0.6 0.118 184.704)",
        "oklch(0.5 0.1 30)",
        "oklch(0.7 0.14 140)",
        "oklch(0.65 0.16 300)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.28 0.01 250)",
      input: "oklch(0.83 0.012 100)",
      muted: "oklch(0.87 0.01 100)",
      mutedForeground: "oklch(0.5 0.01 250)",
      popover: "oklch(0.94 0.006 100)",
      popoverForeground: "oklch(0.28 0.01 250)",
      primary: "oklch(0.78 0.17 85)",
      primaryForeground: "oklch(0.2 0.01 250)",
      ring: "oklch(0.78 0.17 85)",
      secondary: "oklch(0.87 0.01 100)",
      secondaryForeground: "oklch(0.28 0.01 250)",
      sidebar: "oklch(0.89 0.009 100)",
      sidebarAccent: "oklch(0.85 0.015 100)",
      sidebarAccentForeground: "oklch(0.28 0.01 250)",
      sidebarBorder: "oklch(0.83 0.012 100)",
      sidebarForeground: "oklch(0.28 0.01 250)",
      sidebarPrimary: "oklch(0.78 0.17 85)",
      sidebarPrimaryForeground: "oklch(0.2 0.01 250)",
      sidebarRing: "oklch(0.78 0.17 85)",
    },
    isDark: false,
    label: "Serika",
    name: "serika-light",
    pair: "serika-dark",
    swatches: ["#e1e1d6", "#e2b714", "#323437", "#d1d0c5"],
  },
  {
    colors: {
      accent: "oklch(0.87 0.035 128)",
      accentForeground: "oklch(0.28 0.04 145)",
      background: "oklch(0.96 0.015 128)",
      border: "oklch(0.85 0.03 128)",
      card: "oklch(0.96 0.015 128)",
      cardForeground: "oklch(0.28 0.04 145)",
      chartColors: [
        "oklch(0.55 0.1 140)",
        "oklch(0.65 0.12 160)",
        "oklch(0.7 0.08 100)",
        "oklch(0.5 0.08 180)",
        "oklch(0.75 0.1 120)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.28 0.04 145)",
      input: "oklch(0.85 0.03 128)",
      muted: "oklch(0.9 0.025 128)",
      mutedForeground: "oklch(0.52 0.04 140)",
      popover: "oklch(0.97 0.012 128)",
      popoverForeground: "oklch(0.28 0.04 145)",
      primary: "oklch(0.55 0.1 140)",
      primaryForeground: "oklch(0.97 0.01 128)",
      ring: "oklch(0.55 0.1 140)",
      secondary: "oklch(0.9 0.025 128)",
      secondaryForeground: "oklch(0.28 0.04 145)",
      sidebar: "oklch(0.94 0.018 128)",
      sidebarAccent: "oklch(0.87 0.035 128)",
      sidebarAccentForeground: "oklch(0.28 0.04 145)",
      sidebarBorder: "oklch(0.85 0.03 128)",
      sidebarForeground: "oklch(0.28 0.04 145)",
      sidebarPrimary: "oklch(0.55 0.1 140)",
      sidebarPrimaryForeground: "oklch(0.97 0.01 128)",
      sidebarRing: "oklch(0.55 0.1 140)",
    },
    isDark: false,
    label: "Botanical",
    name: "botanical-light",
    pair: "everforest-dark",
    swatches: ["#eef1e4", "#7a9a6e", "#3d5a3e", "#c8d5b9"],
  },
  {
    colors: {
      accent: "oklch(0.9 0.035 240)",
      accentForeground: "oklch(0.22 0.05 255)",
      background: "oklch(0.97 0.008 240)",
      border: "oklch(0.88 0.03 240)",
      card: "oklch(0.97 0.008 240)",
      cardForeground: "oklch(0.22 0.05 255)",
      chartColors: [
        "oklch(0.55 0.2 260)",
        "oklch(0.65 0.15 220)",
        "oklch(0.5 0.12 280)",
        "oklch(0.7 0.18 240)",
        "oklch(0.6 0.1 200)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.22 0.05 255)",
      input: "oklch(0.88 0.03 240)",
      muted: "oklch(0.93 0.02 240)",
      mutedForeground: "oklch(0.52 0.04 245)",
      popover: "oklch(0.98 0.005 240)",
      popoverForeground: "oklch(0.22 0.05 255)",
      primary: "oklch(0.55 0.2 260)",
      primaryForeground: "oklch(0.98 0.005 240)",
      ring: "oklch(0.55 0.2 260)",
      secondary: "oklch(0.93 0.02 240)",
      secondaryForeground: "oklch(0.22 0.05 255)",
      sidebar: "oklch(0.95 0.01 240)",
      sidebarAccent: "oklch(0.9 0.035 240)",
      sidebarAccentForeground: "oklch(0.22 0.05 255)",
      sidebarBorder: "oklch(0.88 0.03 240)",
      sidebarForeground: "oklch(0.22 0.05 255)",
      sidebarPrimary: "oklch(0.55 0.2 260)",
      sidebarPrimaryForeground: "oklch(0.98 0.005 240)",
      sidebarRing: "oklch(0.55 0.2 260)",
    },
    isDark: false,
    label: "Ocean",
    name: "ocean-light",
    pair: "tokyo-night",
    swatches: ["#e8f1f8", "#2563eb", "#1e40af", "#bfdbfe"],
  },
  {
    colors: {
      accent: "oklch(0.88 0.025 75)",
      accentForeground: "oklch(0.32 0.005 75)",
      background: "oklch(0.96 0.01 75)",
      border: "oklch(0.87 0.02 75)",
      card: "oklch(0.96 0.01 75)",
      cardForeground: "oklch(0.32 0.005 75)",
      chartColors: [
        "oklch(0.6 0.08 45)",
        "oklch(0.5 0.06 180)",
        "oklch(0.45 0.05 250)",
        "oklch(0.7 0.09 80)",
        "oklch(0.55 0.07 30)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.32 0.005 75)",
      input: "oklch(0.87 0.02 75)",
      muted: "oklch(0.91 0.015 75)",
      mutedForeground: "oklch(0.55 0.015 75)",
      popover: "oklch(0.97 0.008 75)",
      popoverForeground: "oklch(0.32 0.005 75)",
      primary: "oklch(0.32 0.005 75)",
      primaryForeground: "oklch(0.96 0.01 75)",
      ring: "oklch(0.65 0.04 75)",
      secondary: "oklch(0.91 0.015 75)",
      secondaryForeground: "oklch(0.32 0.005 75)",
      sidebar: "oklch(0.94 0.012 75)",
      sidebarAccent: "oklch(0.88 0.025 75)",
      sidebarAccentForeground: "oklch(0.32 0.005 75)",
      sidebarBorder: "oklch(0.87 0.02 75)",
      sidebarForeground: "oklch(0.32 0.005 75)",
      sidebarPrimary: "oklch(0.32 0.005 75)",
      sidebarPrimaryForeground: "oklch(0.96 0.01 75)",
      sidebarRing: "oklch(0.65 0.04 75)",
    },
    isDark: false,
    label: "Paper",
    name: "paper",
    pair: "kanagawa",
    swatches: ["#f5f0e8", "#444444", "#b8a88a", "#d4cbbf"],
  },
  {
    colors: {
      accent: "oklch(0.91 0.025 85)",
      accentForeground: "oklch(0.45 0.03 195)",
      background: "oklch(0.97 0.015 85)",
      border: "oklch(0.88 0.025 85)",
      card: "oklch(0.97 0.015 85)",
      cardForeground: "oklch(0.5 0.03 195)",
      chartColors: [
        "oklch(0.56 0.14 240)",
        "oklch(0.6 0.17 145)",
        "oklch(0.55 0.2 25)",
        "oklch(0.58 0.16 300)",
        "oklch(0.7 0.16 70)",
      ],
      destructive: "oklch(0.55 0.2 25)",
      foreground: "oklch(0.5 0.03 195)",
      input: "oklch(0.88 0.025 85)",
      muted: "oklch(0.93 0.02 85)",
      mutedForeground: "oklch(0.58 0.03 195)",
      popover: "oklch(0.97 0.015 85)",
      popoverForeground: "oklch(0.5 0.03 195)",
      primary: "oklch(0.56 0.14 240)",
      primaryForeground: "oklch(0.97 0.015 85)",
      ring: "oklch(0.56 0.14 240)",
      secondary: "oklch(0.93 0.02 85)",
      secondaryForeground: "oklch(0.45 0.03 195)",
      sidebar: "oklch(0.95 0.018 85)",
      sidebarAccent: "oklch(0.91 0.025 85)",
      sidebarAccentForeground: "oklch(0.45 0.03 195)",
      sidebarBorder: "oklch(0.88 0.025 85)",
      sidebarForeground: "oklch(0.5 0.03 195)",
      sidebarPrimary: "oklch(0.56 0.14 240)",
      sidebarPrimaryForeground: "oklch(0.97 0.015 85)",
      sidebarRing: "oklch(0.56 0.14 240)",
    },
    isDark: false,
    label: "Solarized Light",
    name: "solarized-light",
    pair: "solarized-dark",
    swatches: ["#fdf6e3", "#657b83", "#268bd2", "#eee8d5"],
  },
  {
    colors: {
      accent: "oklch(0.9 0.04 295)",
      accentForeground: "oklch(0.22 0.04 290)",
      background: "oklch(0.97 0.01 295)",
      border: "oklch(0.88 0.035 295)",
      card: "oklch(0.97 0.01 295)",
      cardForeground: "oklch(0.22 0.04 290)",
      chartColors: [
        "oklch(0.5 0.22 290)",
        "oklch(0.65 0.18 310)",
        "oklch(0.55 0.15 270)",
        "oklch(0.7 0.2 295)",
        "oklch(0.6 0.12 250)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.22 0.04 290)",
      input: "oklch(0.88 0.035 295)",
      muted: "oklch(0.93 0.025 295)",
      mutedForeground: "oklch(0.52 0.04 290)",
      popover: "oklch(0.98 0.008 295)",
      popoverForeground: "oklch(0.22 0.04 290)",
      primary: "oklch(0.5 0.22 290)",
      primaryForeground: "oklch(0.98 0.005 295)",
      ring: "oklch(0.5 0.22 290)",
      secondary: "oklch(0.93 0.025 295)",
      secondaryForeground: "oklch(0.22 0.04 290)",
      sidebar: "oklch(0.95 0.015 295)",
      sidebarAccent: "oklch(0.9 0.04 295)",
      sidebarAccentForeground: "oklch(0.22 0.04 290)",
      sidebarBorder: "oklch(0.88 0.035 295)",
      sidebarForeground: "oklch(0.22 0.04 290)",
      sidebarPrimary: "oklch(0.5 0.22 290)",
      sidebarPrimaryForeground: "oklch(0.98 0.005 295)",
      sidebarRing: "oklch(0.5 0.22 290)",
    },
    isDark: false,
    label: "Lavender",
    name: "lavender-light",
    pair: "catppuccin-mocha",
    swatches: ["#f3eef8", "#7c3aed", "#a78bfa", "#ddd6fe"],
  },
  {
    colors: {
      accent: "oklch(0.91 0.04 55)",
      accentForeground: "oklch(0.25 0.04 45)",
      background: "oklch(0.98 0.008 60)",
      border: "oklch(0.9 0.03 58)",
      card: "oklch(0.98 0.008 60)",
      cardForeground: "oklch(0.25 0.04 45)",
      chartColors: [
        "oklch(0.58 0.2 40)",
        "oklch(0.7 0.16 55)",
        "oklch(0.5 0.15 25)",
        "oklch(0.75 0.13 75)",
        "oklch(0.65 0.18 35)",
      ],
      destructive: "oklch(0.577 0.245 27.325)",
      foreground: "oklch(0.25 0.04 45)",
      input: "oklch(0.9 0.03 58)",
      muted: "oklch(0.94 0.02 60)",
      mutedForeground: "oklch(0.55 0.04 50)",
      popover: "oklch(0.99 0.005 60)",
      popoverForeground: "oklch(0.25 0.04 45)",
      primary: "oklch(0.58 0.2 40)",
      primaryForeground: "oklch(0.98 0.005 60)",
      ring: "oklch(0.58 0.2 40)",
      secondary: "oklch(0.94 0.02 60)",
      secondaryForeground: "oklch(0.25 0.04 45)",
      sidebar: "oklch(0.96 0.01 60)",
      sidebarAccent: "oklch(0.91 0.04 55)",
      sidebarAccentForeground: "oklch(0.25 0.04 45)",
      sidebarBorder: "oklch(0.9 0.03 58)",
      sidebarForeground: "oklch(0.25 0.04 45)",
      sidebarPrimary: "oklch(0.58 0.2 40)",
      sidebarPrimaryForeground: "oklch(0.98 0.005 60)",
      sidebarRing: "oklch(0.58 0.2 40)",
    },
    isDark: false,
    label: "Tangerine",
    name: "tangerine",
    pair: "gruvbox-dark",
    swatches: ["#fff5eb", "#ea580c", "#fb923c", "#fed7aa"],
  },
];
